// Core
import React from "react"
import styled from "styled-components"

// SVG Logos
import Logo from "../../../../../../assets/logo/odg-white-logo.svg"

const Container = styled.div`
  margin-top: 30px;
  margin-bottom: 30px;

  img {
    max-width: 100%;
    width: 130px;
    border: 0;
  }
`

export default function LogoContainer() {
  return (
    <Container>
      <img src={Logo} alt="Oceano da Graça" />
    </Container>
  )
}
